// import moment from 'moment'
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['versao']),
  },
  methods: {
    parseDate: (date) => {
      if (!date) return null

      const [day, month, year] = date.split('/')
      var result = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`

      if (result === '1899/12/30') {
        return ''
      } else {
        return result
      }
    },
    formatDiaMesAno (date) {
      if (!date) return null

      date = date.substr(0, 10)

      const [year, month, day] = date.split('-')
      var result = `${day}/${month}/${year}`

      if (result === '30/12/1899') {
          return ''
      } else {
          return result
      }
    },
    formatDate (date) {
      if (!date) return null

      const [year, month] = date.split('-')
      return `${month}/${year}`
    },
    parseMoeda (valor, casasdecimais) {
      if (!valor || valor === 0) {
        return '0,00'
      } else {
        valor = valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: casasdecimais })
        return valor
      }
    },
    parseInteiro (valor) {
      if (!valor || valor === 0) {
        return '0'
      } else {
        valor = valor.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
        return valor
      }
    },
    getFirstDayOfMonth (date) {
      if (!date) return null

      const [year, month] = date.split('-')
      return `${year}-${month}-01`
    },

    carregaInfoSistemaOperacional () {
      if (navigator.appVersion.indexOf('Win') !== -1) localStorage.osname = 'Windows'
      if (navigator.appVersion.indexOf('Mac') !== -1) localStorage.osname = 'MacOS'
      if (navigator.appVersion.indexOf('X11') !== -1) localStorage.osname = 'UNIX'
      if (navigator.appVersion.indexOf('Linux') !== -1) localStorage.osname = 'Linux'
    },

    verificaVersao () {
      if (localStorage.getItem('versao')) {
        if (localStorage.getItem('versao') > this.versao) {
          this.$router.go()
        }
      } else {
        localStorage.setItem('versao', this.versao)
      }
    },
  },
}
